export default __webpack_public_path__ + "static/media/block-trees.200188d9.svg";